<template>
  <!-- <header class="positon-sticky bg-dark d-flex align-items-center"> -->
  <header class="positon-sticky bg-white d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3">
          <a href="/"><img src="../assets/images/volvo-penta.svg" class="logo d-block" alt=""></a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: "site-header"
  }
</script>

<style lang="scss" scoped>
  .container {
    margin-top: 24px;
    margin-bottom: 32px;
  }
  // header { height: 61px; }
  .logo { height: 43px; }
</style>